import { Address } from "./Address";

export interface Authority {
  id: number;
  address: Address;
  name: string | null;
  department: string | null;
  subDepartment: string | null;
  fax: string | null;
  email: string | null;
  beaSafeId: string | null;
  communicationMedium: string | null;
  telephone: string | null;
  "@type"?: "Authority";
}

export function isJsonLdAuthority(obj: unknown): obj is Authority {
  return !!obj && typeof obj === "object" && "@type" in obj && obj["@type"] === "Authority";
}
